<template>
	<div>
		<Sticky 
			v-bind:offset='0.5'
			triggerClass='step'
			ActiveClass='entered'
			v-on:enterFn="handleEnterFn">

			<!-- sticky graphic -->
			<template v-slot:sticky>
				<div>
					<Map :userLoc="userLoc" :step="step" />
					<div class='knd-map__overlay'>
						<div class='knd-overlay__title'>
							Dit is het percentage volwassenen met overgewicht in:
						</div>

						<div class='knd-overlay__charts' :class="{'hide-first-step': hideFirstStep}">


							<div class='knd-chart__item' v-for="(level, index) in levels" :ref="level.ref" :key="'level-' + index">
								<div class='knd-chart-label'></div>
								<div class='knd-chart-bar__container'>
									<div class='knd-chart-bar'></div>
								</div>
								<div class='knd-chart-percentage'></div>
							</div>
						</div>

						<div class='knd-overlay__source knd-source'>
							Bron: <a href="https://statline.rivm.nl/#/RIVM/nl/dataset/50090NED/table" target="_blank">RIVM</a>
						</div>
					</div>	
				</div>

			</template>
			
			<template v-slot:steps>
				<div 
					v-for="(stap, index) in content" 
					:key="index"
					:data-index="index"
					class="step">
					<div class="tekstvak">
						<p v-if="hideFirstStep && index === 0">Op buurt niveau is er geen data bekend.</p>
						<p v-else v-html="parseTekst(stap.tekst)"></p>
					</div>
				</div>

			</template>
		</Sticky>
	</div>
</template>

<script>
import Sticky from '../knd-sticky';
import Map from './kaart';

import './index.scss';


export default {
	name: 'GrafiekStory',
	props: ['content', 'userLoc'],
	data: function() {

		const levels = [
			{label: 'je buurt', percentage: 0, ref: 'buurt'},
			{label:'je gemeente', percentage: 0, ref: 'gemeente'},
			{label:'Nederland', percentage: 50.8, ref: 'nederland'}
		]

		return {
			step: 0,
			levels: levels,
			level: levels[0].label,
			startBlue: '<span class="highlightBlue">',
			startRed: '<span class="highlightRed">',
			end: '</span>',
			hideFirstStep: false
		}
	},
	components: {
		Sticky, 
		Map
	},
	watch: {
			gemeenteSelected: {
				handler(newValue) {
					// this.levels[1].label = newValue.gemeente_naam;
					this.levels[1].percentage = newValue.gemeente_overgewicht;
					this.updateOverlay(this.step);
				},
				deep: true
			},

			buurtSelected: {
				handler(newValue) {
					// this.levels[0].label = newValue.buurt_naam;
					this.levels[0].percentage = newValue.buurt_overgewicht_mediaan;

					if(!newValue.buurt_overgewicht_mediaan) {
						this.hideFirstStep = true;
					}
					this.updateOverlay(this.step);
				},
				deep: true
			}
		},

	computed: {
		gemeenteNaam() {
			return this.startBlue + this.$store.getters.gemeenteSelected.gemeente_naam + this.end;
		},

		buurtNaam() {
			return this.startBlue + this.$store.getters.buurtSelected.buurt_naam + this.end;
		},

		buurtOvergewicht() {
			return this.startRed + this.levels[0].percentage.toString().replace(".", ",") + this.end;
		},

		calcGemeente() {
			return this.startRed + Math.abs(this.levels[1].percentage - this.levels[0].percentage).toFixed(1).toString().replace(".", ",") + this.end;
		},

		calcGemeenteHogerLager() {
			return this.startRed + (this.levels[0].percentage > this.levels[1].percentage ? 'hoger' : 'lager') + this.end;
		},

		calcLandelijk() {
			return this.startRed + Math.abs(this.levels[0].percentage - this.levels[2].percentage).toFixed(1).toString().replace(".", ",") + this.end;
		},

		buurtOvergewichtOndergrens() {
			return this.startRed + this.buurtSelected.buurt_overgewicht_ondergrens.toString().replace(".", ",") + this.end;
		},

		buurtOvergewichtBovengrens() {
			return this.startRed + this.buurtSelected.buurt_overgewicht_bovengrens.toString().replace(".", ",") + this.end;
		},

		buurtSelected() {
			return this.$store.getters.buurtSelected;
		},

		gemeenteSelected() {
			return this.$store.getters.gemeenteSelected;
		}
	},
	methods: {
		parseTekst(tekst) {
			if (this.buurtSelected !== null) {
				let tekstCurly = tekst.replace(/\{\{(.*?)\}\}/g, (match, token) => {
					if (this[token]) {
						tekst = tekst.replace(match, this[token]);
					}
				});
			}
			return tekst;
		},

		handleEnterFn(el) {
			let currentNum = +el.dataset.index;
			let name = this.levels[currentNum].label;

			this.step = currentNum;
			this.level = this.levels[currentNum].label;

			this.updateOverlay(this.step);
		},

		updateOverlay(currentNum) {
			for(var i = 0; i <= this.levels.length -1; i++ ) {
				let currentLevel = this.levels[i];

				let percentage = i <= currentNum ? currentLevel.percentage : 0;

				let bar = this.$refs[currentLevel.ref].querySelector('.knd-chart-bar');

				if(!bar) {
					return;
				}

				let label = this.$refs[currentLevel.ref].querySelector('.knd-chart-label');
				let percentageEl = this.$refs[currentLevel.ref].querySelector('.knd-chart-percentage');

				bar.style.width = percentage + '%';
				percentageEl.innerHTML = percentage ? currentLevel.percentage.toString().replace(".", ",") + '%' : '';
				label.innerHTML = percentage ? currentLevel.label : '';
			}
		}
	}
}
</script>